import { render } from "./AppInstallBanner.vue?vue&type=template&id=2429ad60&ts=true"
import script from "./AppInstallBanner.vue?vue&type=script&lang=ts"
export * from "./AppInstallBanner.vue?vue&type=script&lang=ts"

import "./AppInstallBanner.vue?vue&type=style&index=0&id=2429ad60&lang=css"

import exportComponent from "/Users/harshit/Documents/Work/notify/notifymobileweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__